export default __webpack_public_path__ + "static/media/pause.d573bfc6.svg";